import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class IframeModalService {
  private iframeUrlSubject = new BehaviorSubject<string | null>(null);
  iframeUrl$ = this.iframeUrlSubject.asObservable();

  open(url: string): void {
    this.iframeUrlSubject.next(url);
  }

  close(): void {
    this.iframeUrlSubject.next(null);
  }
}


// WEBPACK FOOTER //
// /app/src/app/services/general/fullscreen.service.ts